import React, { Component } from 'react';
import Fab from '@material-ui/core/Fab';
import Paper from '@material-ui/core/Paper';
import SvgIcon from '@material-ui/core/SvgIcon';
import TextField from "@material-ui/core/TextField";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {
  DoneIcon,
  DirectionsIcon,
  EditIcon,
  PhoneIcon
} from '../bundles/IconsBundle';
import MapContainer from "./MapContainer";
import moment from 'moment';
import {
  SelectBockByID,
  SetBockValue,
  SavePropertyValue,
  SaveData,
  AddBockToDatabase,
  SelectAppointmentByID,
  SaveDataBock,
  DeleteDBBocks,
  SetPropertyValue
} from "../actions/TaskActions";
import { setTitle } from '../actions/AppActions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  SelectedAppSelector,
  SelectedBockSelector
} from "../selectors/SelectedAppointmentSelector";
import Quagga from 'quagga';
import Scanner from './Scanner';
// import Result from './Result';
import DbTasks from '../db/DbTasks';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from '@material-ui/icons/Delete';
import MessageBox from './dialogs/MessageBox';
import { Text } from '../extensions/LangaugeContainer';

const styles = {
  paperTop: {
    margin: "5px",
    boxShadow: "1px 1px 1px 1px #AAA",
    borderRadius: "0px",
    textAlign: "center",
    color: "#444",
    width: "100%",
    fontSize: 16
  },
  paper: {
    margin: "5px",
    marginTop: "10px",
    boxShadow: "1px 1px 1px 1px #AAA",
    borderRadius: "0px",
    textAlign: "left",
    color: "#444",
    fontSize: 16
  },
  paperTitle: {
    color: "#FFF",
    marginLeft: "5px"
  },
  paperTitleBg: {
    backgroundColor: "#00B0DE",
    fontSize: 18, paddingTop: "5px",
    paddingBottom: "5px"
  },
  div: {
    display: "block",
    float: "left",
    textAlign: "left",
    paddingLeft: "10px",
    zIndex: 999
  },
  cont: {
    marginLeft: "5px",
    paddingTop: "0px",
    paddingBottom: "0px",
    marginRight: "5px",
  },
  fabs: {
    zIndex: 999,
    boxShadow: "1px 1px 1px 1px #AAA",
    backgroundColor: "#03A9F4",
    color: "white",
    margin: "10px"
  },
  map: {
    width: "70%",
    height: "50vh",
    margin: "10px 10% 10px 15%",
    overflowY: "visible"
  }
}
class BockAbholung extends Component {

  state = {
    showManualCode: false,
    code: "",
    qrShow: 'none',
    result: 'No result',
    scanning: false,
    results: [],
    deleteDialogOpen: false,
    SelectedBockId: 0,
    auftragFertigDialogOpen: false
  }

  componentDidMount() {
    moment.locale("de");
    this.props.setTitle(<Text tid="bockPickUp"/>);
    this.props.SelectAppointmentByID(this.props.match.params.id);
  }

  componentWillUnmount() {
    Quagga.offDetected(this._onDetected);
  }

  _onDetected = async result => {
    console.log("OnDetected :", result);
    if (result.codeResult.code.length === 15) {
      this.setState({ results: this.state.results.concat([result]) });
      this.setState({ scanning: false });
      this.insertBock(result.codeResult.code);
    } else {
      console.log("Skeniranje neuspješno : ", result.codeResult.code);
    }

    //this.props.onDetected(result);
  }

  insertBock = async res => {
    let specifiedBock = new DbTasks().getSpeficiedBock;
      let bock = await specifiedBock(res);
      console.log("Bock barcode : ", res);
      if (bock.hasOwnProperty("Bock_Nr")) {
        //update postojećeg boka
        bock.Status = 2;
        bock.DatePickUp = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        bock.ToUpload = 1;
        bock.UniqueID = this.props.app.UniqueID

        this.props.SaveDataBock(bock);
      } else {
        let bockObjToAdd = {
          AuftragNr: '',
          Bereit: null,
          Bock_Nr: res,
          DateLeft: '',
          DatePickUp: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          FirmaID: null,
          Kunden_Nr: '',
          Latitude: '',
          Longitude: '',
          PlanedID: '',
          Status: 2,
          Strasse: '',
          ToUpload: 1,
          ekName: '',
          ekOrt: '',
          ekPLZ: '',
          to_del: 0,
          UniqueID: this.props.app.UniqueID
        }
        // Dodaj skenirani bock u bazu (Ostali podaci se popunjavaju kad se bock ostavi na lokaciju.)
        this.props.AddBockToDatabase(bockObjToAdd);
      }
  }

  _addBockManualy = () => {
    if(this.state.code.length !== 15){
      alert("Barcode length is wrong !")
    }else{
      this.insertBock(this.state.code);
      this.manualCode();
    }    
  }

  handleAdressChange = e => {
    if (e) {
      switch (e.target.name) {
        case "EkStrasse":
          this.props.SaveData(this.props.app, { EkStrasse: e.target.value })
          this.getNewCoords(this.props.app.EkOrt, e.target.value);
          break;
        case "EkOrt":
          this.props.SaveData(this.props.app, { EkOrt: e.target.value })
          this.getNewCoords(e.target.value, this.props.app.Strasse);
          break;
        case "EkPLZ":
            this.props.SaveData(this.props.app, { EkPLZ: e.target.value })
            break;
        default:
          break;
      }
    }
  }

  getNewCoords = (ort, strasse) => {
    fetch("https://maps.googleapis.com/maps/api/geocode/json?address=" + strasse + "," + ort + "&key=AIzaSyD2eK5LTngWgTTvyt17ijwNYTzwoGfhk6Q", {
      method: "GET",
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          return false;
        }
      })
      .then(data => {
        //console.log(data.results[0].geometry.location.lat);
        this.props.SetPropertyValue(this.props.app, 'Latitude', data.results[0].geometry.location.lat);
        this.props.SetPropertyValue(this.props.app, 'Longitude', data.results[0].geometry.location.lng);
        this.props.SaveData(this.props.app, { Lat: data.results[0].geometry.location.lat })
        this.props.SaveData(this.props.app, { Lng: data.results[0].geometry.location.lng })
      })
      .catch(function (err) {
        return console.log("Error", err);
      });
  }

  manualCode = () => {
    this.setState({ ...this.state, showManualCode: !this.state.showManualCode })
  }

  handleCodeChange = (e) => {
    this.setState({ ...this.state, code: e.target.value })
  }

  scan = () => {
    this.setState({ scanning: !this.state.scanning });
  }

  handleError = err => {
    console.error(err)
  }

  deleteScannedBock = () => {
    this.props.DeleteDBBocks(this.state.SelectedBockId);
    this.setState({deleteDialogOpen: false});
    console.log("Brisanje skeniranog boka.");
  }

  openDeleteDialog = (id) => {
    this.setState({ deleteDialogOpen: true, SelectedBockId: id  });
  }

  closeDeleteDialog = () => {
    this.setState({ deleteDialogOpen: false });
  }

  closeAuftragDialog = () => {
    this.setState({auftragFertigDialogOpen: false});
  }

  fertigAuftrag = () => {
    this.props.SaveData(this.props.app, {Geliefert: 1, GeliefertDescription: "Bock rückgabe"});
    this.setState({auftragFertigDialogOpen: false});
  }

  fertigAuftragDialog = () => {
    this.setState({auftragFertigDialogOpen: true})
  }

  render() {
    const app = this.props.app;
    let scannedBocks = this.props.scannedBocks || [];
    //console.log('bockAbholung props:', this.props.app);
    return <div style={styles.cont}>
      <div>
        <Fab size='medium' onClick={this.fertigAuftragDialog} style={styles.fabs} aria-label="Done" >
          <DoneIcon />
        </Fab>
        <Fab size='medium' style={styles.fabs} aria-label="ScanCode" onClick={this.scan}>
          <SvgIcon>
            <path fill="#FFFFFF" d="M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z" />
          </SvgIcon>
        </Fab>
        <Fab
          size='medium'
          style={styles.fabs}
          aria-label="Directions"
          href={
            "google.navigation:q=" +
            this.props.app.EkStrasse +
            " " +
            this.props.app.EkPLZ +
            " " +
            this.props.app.EkOrt
          }
        >
          <DirectionsIcon />
        </Fab>
        <Fab size='medium' style={styles.fabs} aria-label="ManualCode" onClick={this.manualCode}>
          <EditIcon />
        </Fab>
      </div>
      {(this.state.showManualCode) && (
        <div>
          <Paper style={styles.paperTop} elevation={2}>
            <div>
              <TextField type='text' style={styles.paperinput}
                label={<Text tid="bockCode"/>}
                value={this.state.code}
                onChange={this.handleCodeChange}
              />
            </div>
            <div>
              <Button
                size="medium"
                elevation="1"
                style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA", margin: "5px" }}
                onClick={this._addBockManualy}
              >
                <Text tid="finish"/>
                <DoneIcon style={{ color: "#00B0DE", marginLeft: "5px" }} />
              </Button>
            </div>

          </Paper>
        </div>
      )}

      <div>
        {/* <button onClick={this.scan}>{this.state.scanning ? 'Stop' : 'Start'}</button> */}
        {/* <ul className="results">
          {this.state.results.map((result) => (<Result key={result.codeResult.code} result={result} />))}
        </ul> */}
        {this.state.scanning ? <Scanner onDetected={this._onDetected} /> : null}
      </div>

      <Paper style={styles.paper} elevation={2}>
        <div>
          <Typography component="p" style={styles.paperTitleBg}>
            <span style={styles.paperTitle}><Text tid="bockPickUp"/></span>
          </Typography>
        </div>
        <div>
          <span style={{ verticalAlign: "middle", display: "inline-block" }}>
            <Typography component="p" style={{ fontSize: 16, paddingTop: "4px" }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="street"/>: </span>
            </Typography>
          </span>
          <span>
            <TextField
              value={app.EkStrasse || ""}
              name="EkStrasse"
              onChange={(e) => this.props.SetPropertyValue(this.props.app, e.target.name, e.target.value)}
              onBlur={(e) => this.handleAdressChange(e)}
              style={{ width: "70%" }}
            />
          </span>
        </div>
        <div>
          <span style={{ verticalAlign: "middle", display: "inline-block" }}>
            <Typography component="p" style={{ fontSize: 16, paddingTop: "4px" }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="zipCodePlace"/> : </span>
            </Typography>
          </span>
          <span>
            <TextField
              value={app.EkOrt || ""} //+ " " + app.EkPLZ
              name="EkOrt"
              onBlur={(e) => this.handleAdressChange(e)}
              onChange={(e) => this.props.SetPropertyValue(this.props.app, e.target.name, e.target.value)}
              style={{ width: "45%", marginLeft: "6px" }}
            />
          </span>
          <span>
            <TextField
              value={app.EkPLZ || ""} //+ " " + app.EkPLZ
              name="EkPLZ"
              onBlur={(e) => this.handleAdressChange(e)}
              onChange={(e) => this.props.SetPropertyValue(this.props.app, e.target.name, e.target.value)}
              style={{ width: "24%", marginLeft: "4px" }}
            />
          </span>
        </div>
        {(app.Tel_1 !== null && app.Tel_1 !== "") && (
          <div style={{ lineHeight: "28px", verticalAlign: "middle" }}>
            <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start" style={{ marginLeft: "0px" }}>
              <Grid item xs={9} sm={9} md={9} lg={9}>
                <Typography component="p" style={{ fontSize: 16, paddingTop: "5px" }}>
                  <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="number"/>: </span><span>{app.Tel_1}</span>
                </Typography>
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} style={{ textAlign: "right", paddingRight: "5px" }}>
                <Button
                  size="small"
                  elevation="1"
                  aria-label="Tel"
                  style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA" }}
                  href={"tel:" + app.Tel_1}
                >
                  <PhoneIcon style={{ color: "#00B0DE" }} />
                </Button>
              </Grid>
            </Grid>
          </div>
        )}
        {(app.Tel_2 !== null && app.Tel_2 !== "") && (
          <div style={{ marginTop: "5px" }}>
            <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start" style={{ marginLeft: "0px" }}>
              <Grid item xs={9} sm={9} md={9} lg={9}>
                <Typography component="p" style={{ fontSize: 16, paddingTop: "5px" }}>
                  <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="number"/>:</span><span>{app.Tel_2}</span>
                </Typography>
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} style={{ textAlign: "right", paddingRight: "5px" }}>
                <Button
                  size="small"
                  elevation="1"
                  aria-label="Tel"
                  style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA" }}
                  href={"tel:" + app.Tel_2}
                >
                  <PhoneIcon style={{ color: "#00B0DE" }} />
                </Button>
              </Grid>
            </Grid>
          </div>
        )}
        <div>
          <Typography component="p" style={{ fontSize: 16 }}>
            <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="bockNumber"/>: </span><span>{app.Bock}</span>
          </Typography>
        </div>
        <div>
          <Typography component="p" style={{ fontSize: 16 }}>
            <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="deliveryDate"/>: </span><span>{moment(app.DestinationDate).format("DD.MM.YYYY")}</span>
          </Typography>
        </div>
        <div>
          <Typography component="p" style={{ fontSize: 16 }}>
            <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="deliveryTime"/>: </span><span>{moment(app.DestinationDate).format("HH:mm")}</span>
          </Typography>
        </div>
        {(app.Notiz !== null && app.Notiz !== "") && (
          <div>
            <Typography component="p" style={{ fontSize: 16 }}>
              <span style={{ color: "#00B0DE", padding: "5px" }}><Text tid="driverNotes"/>: </span><span>{app.Notiz}</span>
            </Typography>
        </div>
        )}
      </Paper>
      <Paper style={styles.paper} elevation={2}>
        <div>
          <Typography component="p" style={styles.paperTitleBg}>
            <span style={styles.paperTitle}><Text tid="scannedItems"/></span>
          </Typography>
          {scannedBocks.length !== 0 && (
            <Table>
              <TableBody>
                {scannedBocks.map(val => (
                  <TableRow key={val.id}>
                    <TableCell>
                      <span style={{ color: "#00B0DE", padding: "0px", fontSize: 16 }}>
                        {val.Bock_Nr}</span>
                    </TableCell>
                    <TableCell style={{ paddingRight: "5px", textAlign: "right" }}>
                      <Button
                        size="small"
                        elevation="1"
                        aria-label="Edit"
                        value={val.id}
                        style={{ boxShadow: "0px 1px 0.5px 0.5px #AAA", marginRight: "5px" }}

                      >
                        <DeleteIcon onClick={() => this.openDeleteDialog(val.id)} style={{ color: "#00B0DE" }} />

                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
        <MessageBox
          Title={<Text tid="bockDelete"/>}
          Mesasge={<Text tid="bockDeleteMessage"/>}
          CancelText={<Text tid="yes"/>}
          AcceptText={<Text tid="no"/>}
          open={this.state.deleteDialogOpen}
          type={this.state.type}
          handleClose={this.closeDeleteDialog}
          handleAccept={this.deleteScannedBock} />

        <MessageBox
          Title={<Text tid="orderFinish"/>}
          Mesasge={<Text tid="bockDeleteMessage"/>}
          CancelText={<Text tid="yes"/>}
          AcceptText={<Text tid="no"/>}
          open={this.state.auftragFertigDialogOpen}
          handleClose={this.closeAuftragDialog}
          handleAccept={this.fertigAuftrag} />
      </Paper>
      <div>
        <MapContainer kunde={{ lat: 50.89504, lng: 13.88062 }} map={styles.map} />
      </div>
    </div>
  }
}

const mapStateToProps = state => ({
  app: SelectedAppSelector(state),
  scannedBocks: SelectedBockSelector(state),
  enteredData: state.tasks.enteredData,
});

//const withLoader = Loader(TaskView);

const connected = connect(mapStateToProps, {
  setTitle,
  SelectBockByID,
  SetBockValue,
  SavePropertyValue,
  SaveData,
  AddBockToDatabase,
  SelectAppointmentByID,
  SaveDataBock,
  DeleteDBBocks,
  SetPropertyValue
})(BockAbholung);

export default withRouter(connected);